module.exports = __webpack_public_path__ + "static/media/cy5050.a8765a8d.mp3";